/** @type {Record<string, string | Record<string, string>>} */
const strings = {
  nav: {
    today: 'اليوم',
    appointments: 'المواعيد',
    onlineBookings: 'الحجز أونلاين',
    checkout: 'الدفع',
    customers: 'العملاء',
    services: 'الخدمات',
    staff: 'الموظفون',
    cash: 'الصندوق',
    products: 'المنتجات',
    packages: 'الباقات',
    sales: 'المبيعات',
    reports: 'التقارير',
    leads: 'العملاء المحتملون',
    hr: 'الموارد البشرية',
    approvals: 'الموافقات',
    accounts: 'الحسابات',
    sendOffers: 'إرسال عروض',
    settings: 'الإعدادات',
    command: 'اليوم',
    calendar: 'المواعيد',
    pos: 'الدفع',
    guests: 'العملاء',
    team: 'الموظفون',
    insights: 'المبيعات',
    groups: {
      daily: 'اليومي',
      catalog: 'الكتالوج',
      money: 'المبيعات',
      more: 'المزيد',
    },
  },
  auth: {
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    rememberMe: 'تذكرني',
    signIn: 'تسجيل الدخول',
    signingIn: 'جاري تسجيل الدخول…',
    twoFactorTitle: 'المصادقة الثنائية',
    twoFactorHint: 'أدخلي الرمز من تطبيق المصادقة',
    twoFactorHintRecovery: 'أدخلي الرمز من تطبيق المصادقة أو رمز الاسترداد.',
    recoveryCode: 'رمز الاسترداد',
    authCode: 'رمز المصادقة',
    continue: 'متابعة',
    verifying: 'جاري التحقق…',
    useRecoveryCode: 'استخدام رمز الاسترداد',
    useAuthenticatorCode: 'استخدام رمز التطبيق',
    backToSignIn: 'العودة لتسجيل الدخول',
  },
  common: {
    search: 'بحث…',
    searchCatalog: 'بحث في القائمة',
    notifications: 'الإشعارات',
    language: 'اللغة',
    english: 'English',
    arabic: 'العربية',
    loading: 'جاري التحميل…',
  },
  search: {
    title: 'بحث القائمة',
    open: 'فتح بحث القائمة',
    placeholder: 'ابحث في الصفحات والإعدادات…',
    placeholderShort: 'بحث القائمة…',
    noResults: 'لا توجد عناصر مطابقة',
    groups: {
      main: 'القائمة',
      settings: 'الإعدادات',
      admin: 'الإدارة',
      masters: 'البيانات والفهرس',
      workspace: 'مساحة العمل',
    },
  },
  notifications: {
    title: 'الإشعارات',
    new: 'جديد',
    newCountLabel: 'جديد',
    unreadLabel: 'غير مقروء',
    empty: 'لا توجد إشعارات جديدة',
    emptyHint: 'ستظهر حجوزات الضيوف الجديدة هنا.',
    onlineBooking: 'طلب حجز عبر الإنترنت',
    guestFallback: 'ضيف',
    viewAll: 'عرض كل الحجوزات',
    needsApproval: 'مراجعة',
    loading: 'جاري تحميل الإشعارات…',
    toastTitle: 'حجز عبر الإنترنت',
    toastAction: 'اضغط للمراجعة',
    dismiss: 'إغلاق',
  },
  pos: {
    services: 'الخدمات',
    quickKeys: 'اختصارات سريعة',
    retail: 'منتجات',
    categories: 'الفئات',
    genderPricing: 'تسعير الجنس وفلتر القائمة',
    ladies: 'سيدات',
    gents: 'رجال',
    allCategories: 'جميع الفئات',
    ticket: 'الفاتورة',
    ticketSummary: 'الفاتورة · {{lines}} · {{minutes}} د',
    loadTicket: 'تحميل فاتورة',
    loadAppointment: 'تحميل موعد',
    guestRequired: 'الضيف مطلوب',
    guestRequiredHint: 'أضف ضيفًا بالاسم ورقم الهاتف قبل الدفع أو التعليق.',
    shortcuts: {
      customer: 'الضيف',
      appointment: 'موعد',
      pay: 'دفع',
      hold: 'تعليق',
      package: 'باقة',
      redeem: 'استبدال',
      recall: 'استرجاع',
      qty: 'الكمية',
      close: 'إغلاق',
    },
  },
  today: {
    greetingMorning: 'صباح الخير',
    greetingAfternoon: 'مساء الخير',
    greetingEvening: 'مساء الخير',
    subtitle: 'إليك ملخص يوم الصالون.',
    subtitleBranch: 'إليك ملخص يوم {{branch}}.',
    loading: 'جاري التحميل…',
    error: 'تعذّر تحميل ملخص اليوم. تحققي من الاتصال وحاولي مرة أخرى.',
    moneyToday: 'مبيعات اليوم',
    vsYesterday: '{{pct}}% عن أمس',
    vsYesterdayUp: 'أعلى من أمس',
    vsYesterdayDown: 'أقل من أمس',
    vsYesterdayFlat: 'مثل أمس',
    dailyGoal: 'هدف اليوم',
    toGoal: '{{amount}} للوصول للهدف',
    goalReached: 'تم تحقيق الهدف — يوم رائع!',
    appointmentsToday: 'المواعيد',
    scheduledToday: 'محجوزة اليوم',
    completed: 'مكتملة',
    servicesDone: 'خدمات منتهية',
    weekSales: 'هذا الأسبوع',
    lastSevenDays: 'آخر 7 أيام',
    avgTicket: 'متوسط الفاتورة',
    perSaleToday: 'لكل عملية بيع اليوم',
    guestsToday: 'ضيوف اليوم',
    newReturning: '{{new}} جديد · {{returning}} عائد',
    weekChartTitle: 'مبيعات الأسبوع',
    nextUp: 'التالي',
    noAppointments: 'لا مواعيد قادمة اليوم.',
    bookAppointment: 'حجز موعد',
    newAppointment: 'موعد جديد',
    startPos: 'نقطة البيع',
    arrivingSoon: '{{count}} يصلون خلال ساعة',
    todayFlow: 'جدول اليوم',
    flowSummary: '{{completed}} منتهية حتى الآن',
    weekTrend: 'آخر 7 أيام',
    nowServing: 'قيد الخدمة الآن',
    upNext: 'التالي',
    inSalon: 'في الصالون',
    stylistsBusy: 'موظفون مشغولون',
    occupancy: 'الإشغال',
    quickAccess: 'وصول سريع',
    quickAccessHint: 'انتقلي لمهامك اليومية.',
    quickAppointments: 'عرض وحجز المواعيد',
    quickOnline: 'مراجعة طلبات الحجز أونلاين',
    quickPos: 'استلام الدفع وطباعة الإيصال',
    quickCustomers: 'البحث عن عميل أو إضافته',
    quickServices: 'عرض الخدمات والأسعار',
    quickStaff: 'عرض الفريق',
    quickSales: 'تقارير المبيعات',
    quickOffers: 'إرسال عروض واتساب',
    quickSettings: 'ساعات الصالون والشعار والفريق',
    heroBookVisit: 'حجز زيارة',
    heroTakePayment: 'استلام الدفع',
    heroFindGuest: 'البحث عن ضيف',
    heroWebRequests: 'طلبات الويب',
    heroPos: 'نقطة البيع',
    heroPriceList: 'قائمة الأسعار',
    heroCashDrawer: 'درج النقد',
  },
  publicBook: {
    currency: '{{amount}} درهم',
    schedule: {
      today: 'اليوم',
      tomorrow: 'غداً',
      morning: 'صباحاً',
      afternoon: 'بعد الظهر',
      evening: 'مساءً',
    },
    hub: {
      eyebrow: 'الحجز عبر الإنترنت',
      title: 'اختر صالوناً',
      errorLoad: 'تعذّر تحميل مواقع الحجز.',
      fallbackTagline: 'احجزي واسترخي',
    },
    home: {
      unavailable: 'صفحة الحجز هذه غير متاحة.',
      welcome: 'مرحباً بك في',
      viewCatalog: 'عرض القائمة',
      contact: 'تواصل',
      phone: 'الهاتف',
      whatsapp: 'واتساب',
      address: 'العنوان',
      directions: 'الاتجاهات',
      openMaps: 'فتح في الخرائط',
      logoAlt: 'شعار {{name}}',
    },
    catalog: {
      unavailable: 'صفحة الحجز هذه غير متاحة.',
      catalog: 'القائمة',
      book: 'احجز',
      searchPlaceholder: 'ابحث عن الخدمات…',
      filterCategories: 'تصفية الفئات',
      done: 'تم',
      allCategories: 'جميع الفئات',
      checkoutBar: '{{count}} خدمة{{suffix}}',
      checkoutTotal: 'الدفع · {{total}}',
      home: 'الرئيسية',
    },
    cart: {
      title: 'سلة الحجز',
      editHint: 'عدّلي الكميات أو أزيلي العناصر قبل الدفع',
      reviewHint: 'راجعي الخدمات لـ {{branch}}',
      close: 'إغلاق',
      empty: 'سلة الحجز فارغة.',
      each: '{{price}} للوحدة',
      remove: 'إزالة',
      quantity: 'الكمية',
      totalItems: 'إجمالي العناصر',
      itemCount: '{{count}} عنصر{{suffix}}',
      subtotal: 'المجموع (بدون ضريبة)',
      vat: 'ضريبة القيمة المضافة (5%)',
      totalIncVat: 'الإجمالي (شامل الضريبة)',
      continue: 'متابعة التفاصيل',
    },
    checkout: {
      details: 'تفاصيل الحجز',
      verifyPhone: 'تأكيد الهاتف',
      confirmed: 'تم تأكيد الحجز',
      close: 'إغلاق',
      manageLink: 'إدارة حجزك',
      addCalendar: 'إضافة للتقويم (.ics)',
      done: 'تم',
      otpPrompt: 'أدخلي الرمز المكوّن من 6 أرقام المرسل{{channel}} إلى {{phone}}.',
      otpChannelWhatsApp: ' عبر واتساب',
      devCode: 'رمز التطوير: {{code}}',
      back: 'رجوع',
      verifying: 'جاري التحقق…',
      verifyBook: 'تحقق واحجز',
      contactDetails: 'بيانات التواصل',
      name: 'الاسم',
      namePlaceholder: 'اسمك',
      phone: 'الهاتف',
      phoneHintUae: 'أدخلي رقم جوال يبدأ بـ 5 (مثل 50 123 4567) بدون الصفر الأول.',
      phoneHintDefault: 'أدخلي رقم الجوال كاملاً بدون الصفر الأول.',
      whatsappOtpHint: 'سنرسل رمز التحقق عبر واتساب إلى هذا الرقم.',
      pickDay: 'اختر يوماً',
      completePhoneFirst: 'أكملي رقم الهاتف أولاً.',
      availableTimes: 'الأوقات المتاحة',
      openSlots: '{{count}} متاح',
      noTimesDay: 'لا توجد أوقات في هذا اليوم. جربي تاريخاً آخر.',
      allBooked: 'جميع الأوقات محجوزة أو قريبة جداً. اختاري تاريخاً آخر.',
      notes: 'ملاحظات (اختياري)',
      notesPlaceholder: 'أي تفضيلات أو طلبات',
      manualReview: '{{branch}} تراجع طلبات الحجز قبل التأكيد.',
      backToCart: 'العودة للسلة',
      pleaseWait: 'يرجى الانتظار…',
      sendWhatsAppCode: 'إرسال رمز واتساب والمتابعة',
      sendCode: 'إرسال الرمز والمتابعة',
      confirmBooking: 'تأكيد الحجز',
      errorLoadSlots: 'تعذّر تحميل الأوقات المتاحة.',
      errorPhone: 'أدخلي رقم الجوال كاملاً مع رمز الدولة.',
      errorSendWhatsApp: 'تعذّر إرسال رمز التحقق عبر واتساب.',
      errorSendCode: 'تعذّر إرسال رمز التحقق.',
      errorVerify: 'رمز التحقق غير صحيح.',
      errorSubmit: 'تعذّر إرسال الحجز.',
      codeSent: 'تم إرسال رمز التحقق.',
      icsTitle: 'موعد {{branch}}',
      icsDescription: 'إدارة الحجز: {{url}}',
      icsFallback: 'حجز عبر الإنترنت',
    },
    manage: {
      expired: 'انتهت صلاحية رابط الحجز أو أنه غير صالح.',
      backHub: 'العودة لمركز الحجز',
      loading: 'جاري تحميل حجزك…',
      allBranches: 'جميع الفروع',
      title: 'إدارة الحجز',
      when: 'الموعد',
      guest: 'الضيف',
      guestFallback: 'ضيف',
      services: 'الخدمات',
      reschedule: 'إعادة الجدولة',
      saving: 'جاري الحفظ…',
      saveTime: 'حفظ الموعد الجديد',
      cancelling: 'جاري الإلغاء…',
      cancelAppointment: 'إلغاء الموعد',
      confirmCancel: 'إلغاء هذا الموعد؟',
      changesClosed: 'التعديلات عبر الإنترنت مغلقة خلال {{hours}} ساعة من موعدك. تواصلي مع الصالون مباشرة إذا احتجت مساعدة.',
      errorCancel: 'تعذّر إلغاء الحجز.',
      errorReschedule: 'تعذّر إعادة الجدولة.',
    },
    aria: {
      goBack: 'رجوع',
      openMenu: 'فتح القائمة',
      closeMenu: 'إغلاق القائمة',
      closeMenuBackdrop: 'إغلاق خلفية القائمة',
      search: 'بحث',
      filter: 'تصفية',
      closeCart: 'إغلاق السلة',
      closeCheckout: 'إغلاق الدفع',
    },
  },
}

export default strings
